import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteCustomerAddress } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

type MutationPayload = {
  customerId: ParameterID
  addressId: ParameterID
}

export function useMutationDeleteCustomerAddress() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationDeleteCustomerAddress'],
    mutationFn: async ({ customerId, addressId }: MutationPayload) => {
      await deleteCustomerAddress(customerId, addressId)

      queryClient.invalidateQueries([
        'QueryGetAllCustomerAddresses',
        Number(customerId),
      ])
    },
  })
}
